import React, { createContext, useContext, useState, useCallback } from 'react';

export type CurrencyCode = 'ILS' | 'USD' | 'EUR';

export const CURRENCY_OPTIONS: { code: CurrencyCode; symbol: string; label: string }[] = [
  { code: 'ILS', symbol: '₪', label: 'Shekel' },
  { code: 'USD', symbol: '$', label: 'Dollar' },
  { code: 'EUR', symbol: '€', label: 'Euro' },
];

const symbolMap: Record<CurrencyCode, string> = {
  ILS: '₪',
  USD: '$',
  EUR: '€',
};

interface CurrencyContextType {
  currency: CurrencyCode;
  symbol: string;
  setCurrency: (c: CurrencyCode) => void;
}

const CurrencyContext = createContext<CurrencyContextType>({
  currency: 'ILS',
  symbol: '₪',
  setCurrency: () => {},
});

export const CurrencyProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [currency, setCurrencyState] = useState<CurrencyCode>(() => {
    const saved = localStorage.getItem('wcc_currency');
    if (saved === 'ILS' || saved === 'USD' || saved === 'EUR') return saved;
    return 'ILS';
  });

  const setCurrency = useCallback((c: CurrencyCode) => {
    setCurrencyState(c);
    localStorage.setItem('wcc_currency', c);
  }, []);

  return (
    <CurrencyContext.Provider value={{ currency, symbol: symbolMap[currency], setCurrency }}>
      {children}
    </CurrencyContext.Provider>
  );
};

export const useCurrency = () => useContext(CurrencyContext);
